import { Controller } from '@hotwired/stimulus'

export default class SelectedItemController extends Controller {
  static targets = ['container']

  updateSelected (event) {
    this.containerTargets.forEach(container => {
      container.classList.remove('selected')
    })

    event.target
      .closest('[data-selected-item-target=container]')
      .classList.add('selected')
  }
}
